module.exports = __webpack_public_path__ + "static/winner-man-44a92c0c7a78f8aa9b149e7c3a69e947.webp";